import { useState } from "react";
import { inputCls, labelCls, FormActions } from "./common";

const vide = { titre: "", slug: "", categorie: "Juridique", date: "", lecture: "5 min", extrait: "", contenu: "" };

export const ArticleForm = ({ initial, onSave, onCancel, saving }) => {
  const [f, setF] = useState(
    initial ? { ...initial, contenu: initial.contenu.join("\n\n") } : vide
  );
  const set = (champ) => (e) => setF({ ...f, [champ]: e.target.value });

  const soumettre = (e) => {
    e.preventDefault();
    onSave({
      titre: f.titre,
      slug: f.slug || undefined,
      categorie: f.categorie,
      date: f.date,
      lecture: f.lecture,
      extrait: f.extrait,
      contenu: f.contenu.split(/\n+/).map((s) => s.trim()).filter(Boolean),
    });
  };

  return (
    <form onSubmit={soumettre} className="space-y-5" data-testid="article-form">
      <div>
        <label htmlFor="af-titre" className={labelCls}>Titre *</label>
        <input id="af-titre" required minLength={3} value={f.titre} onChange={set("titre")} className={inputCls} data-testid="article-form-titre" />
      </div>
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label htmlFor="af-slug" className={labelCls}>Adresse (slug)</label>
          <input id="af-slug" value={f.slug} onChange={set("slug")} className={inputCls} placeholder="généré automatiquement" data-testid="article-form-slug" />
        </div>
        <div>
          <label htmlFor="af-categorie" className={labelCls}>Catégorie *</label>
          <select id="af-categorie" value={f.categorie} onChange={set("categorie")} className={inputCls} data-testid="article-form-categorie">
            <option>Juridique</option>
            <option>Fiscal</option>
            <option>Entrepreneurial</option>
          </select>
        </div>
      </div>
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label htmlFor="af-date" className={labelCls}>Date affichée *</label>
          <input id="af-date" required value={f.date} onChange={set("date")} className={inputCls} placeholder="15 juin 2026" data-testid="article-form-date" />
        </div>
        <div>
          <label htmlFor="af-lecture" className={labelCls}>Temps de lecture</label>
          <input id="af-lecture" value={f.lecture} onChange={set("lecture")} className={inputCls} placeholder="5 min" data-testid="article-form-lecture" />
        </div>
      </div>
      <div>
        <label htmlFor="af-extrait" className={labelCls}>Extrait (résumé) *</label>
        <textarea id="af-extrait" required minLength={10} rows={2} value={f.extrait} onChange={set("extrait")} className={`${inputCls} resize-y`} data-testid="article-form-extrait" />
      </div>
      <div>
        <label htmlFor="af-contenu" className={labelCls}>Contenu * (##/### = intertitres, 1./* = listes, **gras**)</label>
        <textarea id="af-contenu" required rows={10} value={f.contenu} onChange={set("contenu")} className={`${inputCls} resize-y`} placeholder="Séparez les paragraphes et les éléments de liste par des sauts de ligne." data-testid="article-form-contenu" />
      </div>
      <FormActions saving={saving} onCancel={onCancel} />
    </form>
  );
};
